export const api = {
  iTokenVoucher: '/itoken/voucher',
  iTokenVoucherExport: '/itoken/voucher/export',
  iTokenCampaign: '/itoken/campaign',
  iTokenCampaignProductEntitlementDownloadTemplate: '/itoken/download-product-entitlement-template',
  iTokenCampaignTokenProductEntitlementDownloadTemplate: '/itoken/download-token-product-entitlement-template',
  iTokenCampaignProductEntitlementUploadTemplate: '/itoken/upload-product-entitlement',
  iTokenCampaignTokenProductEntitlementUploadTemplate: '/itoken/upload-token-product-entitlement',
  iTokenRedemption: '/itoken/redemption',
  iTokenCampaignPostVouchers: '/itoken/campaign/{id}/post-vouchers',
  iTokenCampaignAccumulationReport: '/accumulation-report',
  iTokenAccumulateCalculation: '/accumulate-calculation',
  iTokenCampaignDeactivate: '/itoken/campaign/{id}/deactivate',
}
